import React from 'react';

export default function AuthLoadingScreen() {
  return (
    // data-console-loading: shown before any console layout mounts, so the
    // light theme styles it directly (src/styles/theme-light.overrides.css).
    <div data-console-loading className="min-h-screen flex items-center justify-center bg-[#050507]">
      <div className="flex items-center gap-3 text-gray-500 text-sm">
        <div className="w-4 h-4 border-2 border-[#B0FC38]/60 border-t-transparent rounded-full animate-spin" />
        <span>Verifying session…</span>
      </div>
    </div>
  );
}
